export { default as InputTextArea } from './input-textarea'



// WEBPACK FOOTER //
// ./src/components/atoms/input-text/index-textarea.ts